import { Box, Typography } from '@mui/material'
import { memo } from 'react'
import { Outlook, outlookToJSON } from '../../proto/generated/candle-data-depot-option-chain'
import {
    CustomOptionSecurityType,
    getOutlookColorClassName,
    OutlookFullName,
    OutlookToName,
} from '../../pages/typings/options.typings'
import './style.css'

type OutlookDisplayProps = {
    record: CustomOptionSecurityType | undefined
    outlook?: Outlook
}

const OutlookDisplay = memo(({ record, outlook: outlookProp }: OutlookDisplayProps) => {
    const outlook = outlookProp ?? record?.oiChanges?.outlook
    if ([Outlook.OUTLOOK_UNKNOWN, Outlook.UNRECOGNIZED, undefined].includes(outlook)) {
        return (
            <Typography className="strike-tooltip-row-value strike-tooltip-single-value" component="span" noWrap>
                -
            </Typography>
        )
    }
    const outlookKey = outlookToJSON(Number(outlook))
    const tag = OutlookToName[outlookKey]
    const fullName = OutlookFullName[outlookKey]
    const colorClass = getOutlookColorClassName(tag)

    return (
        <Box className="strike-tooltip-outlook">
            <Typography className="strike-tooltip-row-value" component="span" noWrap sx={{ minWidth: 0 }}>
                {fullName}
            </Typography>
            {tag ? (
                <span className={`strike-tooltip-outlook-tag ${colorClass}`}>{tag}</span>
            ) : null}
        </Box>
    )
})

export default OutlookDisplay
